import React from 'react';
import Campaigns from '../../components/Campaigns';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function CampaignsPage() {
  return (
    <AppLayout title="Campanhas" subtitle="Criação e acompanhamento" fullWidth>
      <Campaigns />
    </AppLayout>
  );
}

export default CampaignsPage;
